import React, {useEffect, useState} from "react";
import AcceptInvitationForm from "./acceptInvitation/acceptInvitationForm";
import {ActivationType, validateToken} from "../../activation/activationApi";
import {useNavigate, useParams} from "react-router-dom";
import PageTransition from "../PageTransition";
import ActivationError from "../../../components/Activation/ActivationError";
import ActivationSuccess from "../../../components/Activation/ActivationSuccess";
import {Box, CircularProgress} from "@mui/material";

export default function InvitationStages() {
  const [stage, setStage] = useState<string>('accept');
  const [token, setToken] = useState<string>('');
  const params = useParams();
  const navigate = useNavigate();

  function onSuccessAccept() {
    setStage('success');
  }

  async function validateParamsToken() {
    if (!params.token) {
      navigate('/');
      return;
    }

    setStage('loading');
    const paramToken: string = params.token;
    const response = await validateToken(paramToken, ActivationType.INVITATION);
    const data = response.data;

    if (!data.success) {
      setStage('invalidToken');
    } else {
      setStage('accept');
      setToken(paramToken);
    }
  }

  useEffect(() => {
    validateParamsToken();
  }, []);

  return (
    <>
      {
        stage === 'accept'
          ? (
            <PageTransition direction={1}>
              <AcceptInvitationForm
                onSuccessAccept={onSuccessAccept}
                token={token}
              />
            </PageTransition>
          )
          : ''
      }
      {
        stage === 'success'
          ? (
            <PageTransition direction={1}>
              <ActivationSuccess
                messageCategory={"AcceptInvitation.invitationSuccess"}
                onlyContent={false}
              />
            </PageTransition>
          )
          : ''
      }
      {
        stage === 'error'
          ? (
            <PageTransition direction={1}>
              <ActivationError
                messageCategory={"AcceptInvitation.invitationError"}
                onlyContent={false}
              />
            </PageTransition>
          )
          : ''
      }
      {
        stage === 'invalidToken'
          ? (
            <PageTransition direction={1}>
              <ActivationError
                messageCategory={"Activation.invalidTokenPage"}
                onlyContent={false}
              />
            </PageTransition>
          )
          : ''
      }
      {
        stage === 'loading'
          ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <CircularProgress/>
            </Box>
          )
          : ''
      }
    </>
  );
}